import React, { useState, useEffect } from 'react';
import {
  Drawer,
  Box,
  Typography,
  Button,
  TextField,
  MenuItem,
  Divider,
  Paper,
  Dialog,
  IconButton,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTicketStatusHistoryRequest,
  assignTicketRequest,
  getCommentsRequest,
  fetchInstalaxmiAdminRequest,
} from '../../redux/Tickets/ticketSlice';
import { toast } from 'react-toastify';
import TicketCommentsDrawer from './TicketCommentsDrawer';
import { canShowPermission } from '../MainScreens/Permissions/permissionObject';
import CloseIcon from '@mui/icons-material/Close';
import { fetchInstalaxmiUsersRequest } from '../../redux/JewellerList/JewellerSlice';

const TicketItemDrawer = ({ open, onClose, ticket }) => {
  const dispatch = useDispatch();

  const { ticketStatusHistory, comments } = useSelector(
    (state) => state.tickets,
  );
  const instalaxmiAdmin = useSelector(
    (state) => state.jeweller.instalaxmiUsers,
  );
  const instalaxmiuser = useSelector((state) => state.tickets.instalaxmiAdmin);

  const [assignee, setAssignee] = useState('');
  const [historyOpen, setHistoryOpen] = useState(false);
  const [dueDate, setDueDate] = useState('');
  const [showComments, setShowComments] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [previewOpen, setPreviewOpen] = useState(false);
  useEffect(() => {
    const storedPermissions = localStorage.getItem('userPermissions');

    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error('Error parsing stored permissions', error);
      }
    }
  }, []);
  const canEdit = canShowPermission(permissions, 'jeweller', 'edit');
  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  const jewellerID = storedUser?.jeweller;

  useEffect(() => {
    dispatch(fetchInstalaxmiAdminRequest());
    dispatch(fetchInstalaxmiUsersRequest());
  }, [dispatch]);

  // useEffect(() => {
  //   if (ticket) {
  //     setAssignee(ticket.assignedTo?._id || "");

  //     if (ticket.dueDate) {
  //       const date = new Date(ticket.dueDate);
  //       const formatted = date.toISOString().split("T")[0];
  //       setDueDate(formatted);
  //     } else {
  //       setDueDate("");
  //     }
  //   }
  // }, [ticket]);
  useEffect(() => {
    if (open) {
      setAssignee('');
      setDueDate('');
    }
  }, [open]);
  useEffect(() => {
    if (ticket?._id) {
      dispatch(getCommentsRequest(ticket._id));
    }
  }, [ticket]);
  if (!ticket) return null;
  console.log('assignee:', assignee);
  const isAlreadyAssigned = Boolean(
    ticket?.assignedTo &&
    instalaxmiuser?.some(
      (user) =>
        user._id === ticket?.assignedTo?._id ||
        user.name === ticket?.assignedTo?.name,
    ),
  );
  const hideAssignSection = !canEdit && isAlreadyAssigned;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        setHistoryOpen(false);
        onClose();
      }}
    >
      <Box
        sx={{
          width: 420,
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflowY: 'auto',
          background: '#f4f5f7',
          marginTop: '64px',
        }}
      >
        {/* HEADER */}
        <Box mb={2}>
          {!showComments && (
            <>
              {ticket?.file?.trim() ? (
                <Box mb={2}>
                  <img
                    src={ticket.file}
                    alt="ticket"
                    onClick={() => setPreviewOpen(true)}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                    style={{
                      width: '100%',
                      maxHeight: '220px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      cursor: 'pointer',
                    }}
                  />
                </Box>
              ) : null}
            </>
          )}
          <Typography fontWeight={700} fontSize={20}>
            {ticket.title}
          </Typography>

          <Typography mt={1} color="text.secondary">
            {ticket.description}
          </Typography>
        </Box>

        <Divider />
        {showComments ? (
          <>
            <Typography
              sx={{ cursor: 'pointer', color: '#1976d2', mb: 2 }}
              onClick={() => setShowComments(false)}
            >
              ← Back
            </Typography>
            <TicketCommentsDrawer
              comments={comments || []}
              ticketId={ticket._id}
            />
          </>
        ) : (
          <>
            <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
              <Typography fontWeight={600} mb={1}>
                Details
              </Typography>

              <Button
                variant="contained"
                fullWidth
                sx={{ mt: 1, justifyContent: 'space-between' }}
                onClick={() => {
                  setShowComments(true);
                  dispatch(getCommentsRequest(ticket._id));
                }}
              >
                Comments
                <Box
                  sx={{
                    background: '#fff',
                    color: '#1976d2',
                    px: 1,
                    borderRadius: '10px',
                    fontSize: 12,
                  }}
                >
                  {comments?.length || 0}
                </Box>
              </Button>

              <Typography variant="body2" mt={1}>
                Severity: {ticket.severity}
              </Typography>
            </Paper>

            <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
              <Typography fontWeight={600} mb={2}>
                Ticket Info
              </Typography>

              <Box sx={{ mb: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Assigned by
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mt: 0.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      background: '#4caf50',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {ticket?.assignedBy?.name?.charAt(0) || 'U'}
                  </Box>

                  <Typography fontSize={14} fontWeight={500}>
                    {ticket?.assignedBy?.name || 'N/A'}
                  </Typography>
                </Box>
              </Box>

              {/* Due Date */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Due Date
                </Typography>

                <Typography fontSize={14} mt={0.5}>
                  {ticket?.dueDate
                    ? new Date(ticket.dueDate).toLocaleDateString('en-IN')
                    : 'N/A'}
                </Typography>
              </Box>

              {/* Assignee */}
              <Box sx={{ mb: 1 }}>
                <Typography variant="caption" color="text.secondary">
                  Assignee
                </Typography>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mt: 0.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      background: '#1976d2',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {ticket?.assignedTo?.name?.charAt(0) || 'U'}
                  </Box>

                  <Typography fontSize={14} fontWeight={500}>
                    {ticket?.assignedTo?.name || 'Unassigned'}
                  </Typography>
                </Box>
              </Box>
            </Paper>

            {/* ASSIGN */}
            {!hideAssignSection && (
              <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
                <Typography fontWeight={600} mb={1}>
                  Assign Ticket
                </Typography>

                <TextField
                  select
                  fullWidth
                  size="small"
                  value={assignee}
                  onChange={(e) => setAssignee(e.target.value)}
                >
                  <MenuItem value="">Select User</MenuItem>

                  {instalaxmiAdmin?.map((user) => (
                    <MenuItem key={user._id} value={user._id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Due Date"
                  type="date"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={dueDate}
                  onChange={(e) => setDueDate(e.target.value)}
                />
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ mt: 2 }}
                  onClick={() => {
                    if (!assignee) {
                      toast.error('Please select a user');
                      return;
                    }
                    if (!dueDate) {
                      toast.error('Please select a due date');
                      return;
                    }
                    dispatch(
                      assignTicketRequest({
                        ticketId: ticket._id,
                        assignee,
                        dueDate,
                      }),
                    );
                    onClose();
                  }}
                >
                  Assign Ticket
                </Button>
              </Paper>
            )}

            {/* STATUS HISTORY BUTTON */}
            <Button
              variant="outlined"
              sx={{ mt: 3 }}
              onClick={() => {
                if (!historyOpen) {
                  dispatch(getTicketStatusHistoryRequest(ticket._id));
                }
                setHistoryOpen(!historyOpen);
              }}
            >
              {historyOpen ? 'Hide Status History' : 'View Status History'}
            </Button>

            {/* HISTORY SECTION */}
            {historyOpen && (
              <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
                <Typography fontWeight={600} mb={2}>
                  Status History
                </Typography>

                {ticketStatusHistory?.length > 0 ? (
                  ticketStatusHistory.map((s, i) => (
                    <Box
                      key={i}
                      sx={{
                        borderLeft: '3px solid #1976d2',
                        pl: 2,
                        mb: 2,
                      }}
                    >
                      <Typography fontWeight={500}>{s.status}</Typography>

                      <Typography variant="caption" color="text.secondary">
                        {new Date(s.updatedAt).toLocaleString('en-IN')}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography>No Status History Found</Typography>
                )}
              </Paper>
            )}
          </>
        )}
      </Box>
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <Box sx={{ position: 'relative', background: '#000' }}>
          <IconButton
            onClick={() => setPreviewOpen(false)}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              color: '#fff',
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>

          <img
            src={ticket?.file}
            alt="preview"
            style={{
              width: '100%',
              maxHeight: '90vh',
              objectFit: 'contain',
            }}
          />
        </Box>
      </Dialog>
    </Drawer>
  );
};

export default TicketItemDrawer;
